import { AssemblyGroup, StationComponentDesign } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAll() {
  return DesignService.get<readonly AssemblyGroup[]>('public/assemblyGroups');
}

export function getAssemblyGroup(assemblyGroupGuid: string) {
  return DesignService.get<AssemblyGroup>(`public/assemblyGroups/${assemblyGroupGuid}`);
}

export function createAssemblyGroup(
  assemblyGroupCreationProperties: Pick<AssemblyGroup, 'name' | 'notes' | 'componentDesigns'>,
) {
  return DesignService.post<AssemblyGroup>('public/assemblyGroups', { data: assemblyGroupCreationProperties });
}

export function createAssemblyGroupFromLookupCode(
  assemblyGroupCreationProperties: Pick<AssemblyGroup, 'name' | 'notes'>,
  sharedComponentSetLookupCode: string,
) {
  return DesignService.post<AssemblyGroup>('public/assemblyGroups/fromLookupCode', {
    data: { ...assemblyGroupCreationProperties, sharedComponentSetLookupCode },
  });
}

export function updateAssemblyGroup(
  assemblyGroupGuid: string,
  updates: Pick<AssemblyGroup, 'name' | 'notes' | 'archived'>,
) {
  return DesignService.put<AssemblyGroup>(`public/assemblyGroups/${assemblyGroupGuid}`, {
    data: updates,
  });
}

export function putComponentDesigns(
  assemblyGroupGuid: string,
  componentDesigns: { [guid: string]: StationComponentDesign },
) {
  return DesignService.put<AssemblyGroup>(`public/assemblyGroups/${assemblyGroupGuid}/componentDesigns`, {
    data: componentDesigns,
  });
}

export function sendToStation(assemblyGroupGuid: string, stationGuid: string, clearStation: boolean) {
  return DesignService.post<void>(`public/assemblyGroups/${assemblyGroupGuid}/sendToStation`, {
    data: { stationGuid, clearStation },
  });
}
